import type { ReactNode } from "react";
import type { MetricUnitView } from "./observabilityModel";
import styles from "./ObservabilityPage.module.css";

/**
 * 표 탭들이 공유하는 셀 컴포넌트다.
 *
 * Owns: 한 칸의 모양(큰 수치 + 보조 한 줄)과 묶음 경계선의 표현.
 * Does not own: 무엇을 값으로 하고 무엇을 보조로 할지. 이것은 각 행 모델의 describer 가 소유한다.
 */

/**
 * 한 칸이다. 큰 수치와 보조 한 줄을 표시한다. 보조가 비면 그 줄을 만들지 않는다.
 *
 * `div` 가 아니라 `span`(+ `display:block`)을 쓰는 이유: c6 `DataTable` 이 셀 내용을 `Text as="p"`
 * 로 감싼다. `p` 안의 `div` 는 무효 HTML 이고, 브라우저가 단락을 일찍 닫는다.
 *
 * 봉우리 **시각**은 열 폭 때문에 잘리므로 보조 줄에 넣지 않는다. 대신 셀 전체의 툴팁에 그 시각을
 * 표시한다. 봉우리가 없는 칸(창 합·실측 최대)은 툴팁도 없다.
 */
export function UnitCell({
  view,
  boundary = false,
}: {
  view: MetricUnitView;
  boundary?: boolean;
}): ReactNode {
  return (
    <span
      className={boundary ? `${styles.groupBoundary} ${styles.unitCell}` : styles.unitCell}
      title={view.peakAt === "" ? undefined : `최대 ${view.peakAt}`}
    >
      <span className={styles.podMetricValue}>{view.value}</span>
      {view.hint === "" ? null : <span className={styles.podMetricHint}>{view.hint}</span>}
    </span>
  );
}

/** 묶음의 첫 열 머리다. 값 행과 같은 자리에 경계선을 그린다. */
export function BoundaryHeader({ label }: { label: string }): ReactNode {
  return <span className={styles.groupBoundary}>{label}</span>;
}
